/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CollSurplusPool,
  CollSurplusPoolInterface,
} from "../CollSurplusPool";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newActivePoolAddress",
        type: "address",
      },
    ],
    name: "ActivePoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "AssetSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_newBalance",
        type: "uint256",
      },
    ],
    name: "CollBalanceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newTroveManagerAddress",
        type: "address",
      },
    ],
    name: "TroveManagerAddressChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "accountSurplus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "activePoolAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "claimColl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getAssetBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getCollateral",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "receivedERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_activePoolAddress",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManagerAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type CollSurplusPoolConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CollSurplusPoolConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CollSurplusPool__factory extends ContractFactory {
  constructor(...args: CollSurplusPoolConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<CollSurplusPool> {
    return super.deploy(overrides || {}) as Promise<CollSurplusPool>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): CollSurplusPool {
    return super.attach(address) as CollSurplusPool;
  }
  override connect(signer: Signer): CollSurplusPool__factory {
    return super.connect(signer) as CollSurplusPool__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CollSurplusPoolInterface {
    return new utils.Interface(_abi) as CollSurplusPoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CollSurplusPool {
    return new Contract(address, _abi, signerOrProvider) as CollSurplusPool;
  }
}
